export default class Storage {
  /**
   * @param {string} prefix  key 前缀
   * @param {number} expire  默认过期秒数
   * @param {number} driver_type  enum local/session
   */
  constructor({
    prefix = '',
    expire,
    driver_type = 'local'
  } = {}) {
    this.prefix = prefix
    this.expire = expire > 0 ?  expire : 0

    if(driver_type === 'session') {
      this.driver = window.sessionStorage
    } else {
      this.driver = window.localStorage
    }
  }

  /**
   *
   * @param {string} key
   */
  _key(key) {
    return this.prefix + key
  }

  /**
   * 获取所有的本地存储数据对应的 key
   */
  keys() {
    const keys = Object.keys(this.driver)

    if (this.prefix) {
      const index = this.prefix.length

      return keys.map(function(key) {
        return key.substring(index)
      })
    }

    return keys
  }

  /**
   * 清除所有本地存储的数据
   */
  clear() {
    this.driver.clear()
  }

  /**
   *
   * @param {string} key
   */
  remove(key) {
    this.driver.removeItem(this._key(key))
  }

  /**
   *
   * @param {string} key
   * @param {any} value
   * @param {number} expire
   */
  set(key, value, expire) {
    const data = {
      value: value
    }

    if (typeof expire === 'undefined') {
      expire = this.expire
    }

    if (expire) {
      data.expire = Date.now() + expire * 1000
    }

    this.driver.setItem(this._key(key), JSON.stringify(data))
  }

  /**
   *
   * @param {string} key
   */
  get(key) {
    const driverData = this.driver.getItem(this._key(key))

    if (driverData) {
      try {
        const data = JSON.parse(driverData)
        if (data.expire && data.expire < Date.now()) {
          this.remove(key)
        } else {
          return data.value
        }
      } catch (e) {
        console.warn('storage parse value error:', e)
      }
    }

    return null
  }
}
